import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import * as moment from 'moment';
// import './index.css';
var comsCalendar;
document.addEventListener('DOMContentLoaded', function() {  
  var calendarEl = document.getElementById('comsCalendar');
    comsCalendar = new Calendar(calendarEl, {
      plugins: [ interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin ],
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'timeGridWeek,timeGridDay,listWeek'
      },
      buttonText:{
        today:'Heute',
        month:'Monat',
        week:'Woche',
        day:'Tag',
        list:'Liste'
      },
      firstDay:1,
      initialDate: Date.now(),
      initialView: 'timeGridWeek',
      navLinks: true, // can click day/week names to navigate views
      editable: true,
      dayMaxEvents: true, // allow "more" link when too many events
      locale: 'de',
      slotMinTime: "06:00:00",
      slotMaxTime: "20:00:00",
      datesSet: function (info) {
        loadComsData(info);
      },
    });
  
    comsCalendar.render();
  });

  function loadComsData(view) {
    // $(".wpfc-calendar")
    //   .find(".ui-state-highlight")
    //   .css({ background: "#d4e6f3", "border-color": "#7fb4db" });
    console.log(view)
    fetch("https://pvnmav.coms.network/?token=dienstexport", {
  method: "POST",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  body: `start=${moment(view.start).format('YYYY-MM-DD')}&end=${moment(view.end).format('YYYY-MM-DD')}`,
})
  .then(response => response.json())
  .then(data => {
    comsCalendar.removeAllEvents();
    console.log(data.d)
    data.d.forEach((elem, i) => {
      elem["_id"] = i;
      switch (elem.pos) {
        case "1-1":
        case "6-1":
          elem["color"] = "#2F82C3";
          elem["url"] = "https://pvn-mav.at/ordination-dr-fedrizzi/";
          break;
        case "2-1":
          elem["color"] = "#6A4C93";
          elem["url"] = "https://pvn-mav.at/ordination-huerm/";
          break;
        case "3-1":
          elem["color"] = "#8DBF38";
          elem["url"] = "https://pvn-mav.at/ordination-dr-perchthaler/";
          break;
        case "4-1":
          elem["color"] = "#FAC848";
          elem["url"] = "https://pvn-mav.at/ordination-dr-weissenborn/";
          break;
        case "5-1":
          elem["color"] = "#E75864";
          elem["url"] = "https://pvn-mav.at/ordination-dr-winter/";
          break;
        case "100-1":
        case "1-2":
        case "2-2":
        case "3-2":
        case "4-2":
        case "5-2":
        case "6-2":
          elem["color"] = "grey";
          elem["title"] += `\n${elem["postitle"]}`;
          break;
        case "7-1":
        case "8-1":
        case "9-1":
        case "10-2":
          elem["color"] = "#bebdb8";
          break;
      }
      if (elem.pos === "1001-8" || elem.pos === "1001-99") {
        elem["title"] = "Nicht im Dienst: " + elem["postitle"];
        elem["allDay"] = true;
      } else {
        elem["allDay"] = false;
      }
      comsCalendar.batchRendering(function() {
        comsCalendar.addEvent(elem);
      });
    });
  })
  .catch(error => console.error("Error:", error));

  }
  